/* eslint-disable react/jsx-handler-names */
import React, { useRef } from 'react';
import { FiX } from 'react-icons/fi';

import Spinner from '../Spinner';

import { useModal } from '../../hooks/modal';
import useOutsideClick from 'utils/hooks/useOutsideClick';
import Button from '../Button';

import { Wrapper, ModalContainer, Content, LoaderContent } from './styles';

const Modal: React.FC = () => {
  const { modalData, hideModal } = useModal();

  /**
   * Modal Ref
   */
  const modalRef = useRef(null);

  useOutsideClick(modalRef, () => {
    if (modalData.visible && modalData.allowOutsideClick) {
      hideModal();
    }
  });

  return (
    <Wrapper $visible={modalData.visible}>
      <ModalContainer ref={modalRef} width={modalData.width || '500'}>
        {modalData.loading ? (
          <LoaderContent>
            <Spinner />
            <span>Aguarde...</span>
          </LoaderContent>
        ) : (
          <>
            <header>
              <h4>{modalData.title}</h4>
              <button onClick={hideModal}>
                <FiX />
              </button>
            </header>
            <Content>
              {!!modalData.component && <>{modalData.component}</>}
              {!!modalData.callback && (
                <div className="actions">
                  <Button color="default" onClick={hideModal}>
                    FECHAR
                  </Button>
                  <Button onClick={modalData.callback}>
                    {modalData.confirmButtonText
                      ? modalData.confirmButtonText
                      : 'CONFIRMAR'}
                  </Button>
                </div>
              )}
            </Content>
          </>
        )}
      </ModalContainer>
    </Wrapper>
  );
};

export default Modal;
